import { AccountCircle } from "@mui/icons-material";
import { Button, ButtonProps } from "@mui/material";
import { useRouter } from "next/router";
import * as React from "react";
import { useTranslation } from "react-i18next";

export default function SignInButton(props: ButtonProps) {
  const router = useRouter();
  const { t } = useTranslation("common");
  return (
    <Button
      // variant="contained"
      color="primary"
      onClick={(e) => {
        props.onClick && props.onClick(e);
        console.log("pathname", router.pathname);

        if (router.pathname !== "/login/signIn") {
          router.push({
            pathname: "/login/signIn",
            query: { returnUrl: router.asPath },
          });
        }
      }}
      id="loginButton"
    >
      {props.children}
    </Button>
  );
}
